export const formMessages = {
    required: () => 'Required',
    minimumTimeframe: () => 'The date must be at least two hours later than the current date',
    isNumber: () => 'Rate must be in format 00.00',
    minimumRate: () => 'The rate must be more than half of the total price',
    minLength: ({ $params }) => `Must be at least ${$params.minLength.min} characters.`,
    maxLength: ({ $params }) => `Must be less than ${$params.maxLength.max} characters.`
}
